import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkIconModule } from '@shared/link-icon/link-icon.module';
import { JbNavigationBlockModule } from 'jb-component-library';

import { SecondaryNavBlockListComponent } from './secondary-nav-block-list.component';

@NgModule({
  imports: [CommonModule, JbNavigationBlockModule, LinkIconModule],
  declarations: [SecondaryNavBlockListComponent],
  exports: [SecondaryNavBlockListComponent],
})
export class SecondaryNavBlockListModule {}
